import { action } from 'typesafe-actions';

import { ModalFilterTypes } from './types';

// Set Open modal
export const setOpenModal = (payload: { openModal: boolean }) =>
  action(ModalFilterTypes.SET_OPEN_MODAL, payload);
